import React from 'react';
import SectionCard from './SectionCard';
import {
  SettingOutlined,
  SafetyCertificateOutlined,
  CreditCardOutlined,
  AppstoreOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { useLanguage } from 'src/providers/LanguageProvider';
import { useNavigate } from 'react-router';

type Props = {
  subscriptionsLength: number;
};

const FastActions: React.FC<Props> = ({ subscriptionsLength }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const actions = [
    {
      key: 'SECURITY',
      icon: <SafetyCertificateOutlined />,
      label: t('SECURITY'),
      route: '/security',
    },
    {
      key: 'INVOICES',
      icon: <CreditCardOutlined />,
      label: t('INVOICES'),
      route: '/my-invoices',
    },
    {
      key: 'SUBSCRIPTIONS',
      icon: <AppstoreOutlined />,
      label: `${t('SUBSCRIPTIONS')} (${subscriptionsLength})`,
      route: '/subscriptions',
    },
    {
      key: 'SUPPORT',
      icon: <InfoCircleOutlined />,
      label: t('SUPPORT'),
      route: '/support',
    },
  ];

  return (
    <SectionCard icon={<SettingOutlined />} title={t('QUICK_ACTIONS')}>
      <Row gutter={[8, 8]}>
        {actions.map((a) => (
          <Col span={12} key={a.key}>
            <Button
              onClick={() => navigate(a.route)}
              block
              size="large"
              style={{ borderRadius: 12 }}
              icon={a.icon}
            >
              {a.label}
            </Button>
          </Col>
        ))}
      </Row>
    </SectionCard>
  );
};

export default FastActions;
